import { Component } from '@theme/component';

class MixoraFirstOrderPopup extends Component {
  #timer;
  #abortController;

  connectedCallback() {
    super.connectedCallback();
    this.#abortController?.abort();
    this.#abortController = new AbortController();
    this.addEventListener('click', (event) => {
      if (event.target instanceof Element && event.target.closest('.mixora-offer__copy')) {
        this.copyCode();
      }
    }, { signal: this.#abortController.signal });

    try {
      if (sessionStorage.getItem('mixora-first-order-offer-shown') === 'true') return;
    } catch {}

    const delay = Math.max(1, Number(this.dataset.delaySeconds) || 5) * 1000;
    this.#timer = window.setTimeout(() => {
      customElements.whenDefined('dialog-component').then(() => {
        const dialog = this.querySelector('dialog-component');
        if (typeof dialog?.showDialog !== 'function') return;
        try { sessionStorage.setItem('mixora-first-order-offer-shown', 'true'); } catch {}
        dialog.showDialog();
      });
    }, delay);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#abortController?.abort();
    window.clearTimeout(this.#timer);
  }

  async copyCode() {
    const button = this.querySelector('.mixora-offer__copy');
    const code = this.querySelector('[ref=code]')?.textContent?.trim();
    const status = this.querySelector('[ref=copyStatus]');
    if (!button || !code) return;
    try {
      await navigator.clipboard.writeText(code);
      button.textContent = button.dataset.copiedLabel || 'Copiado';
      if (status) status.textContent = button.dataset.copiedLabel || 'Código copiado';
    } catch {
      if (status) status.textContent = code;
    }
  }
}

if (!customElements.get('mixora-first-order-popup')) {
  customElements.define('mixora-first-order-popup', MixoraFirstOrderPopup);
}
